import React from "react"
import { ui } from "../../../shared/styles/uiSystem"

export function SummaryTile({ title, value, subtitle, tone = "neutral" }) {
  const visual =
    tone === "danger"
      ? { bg: "#fff7ed", border: "#fed7aa", value: "#c2410c" }
      : tone === "info"
        ? { bg: "#eff6ff", border: "#bfdbfe", value: "#1d4ed8" }
        : tone === "success"
          ? { bg: "#f0fdf4", border: "#bbf7d0", value: "#166534" }
          : tone === "warning"
            ? { bg: "#fffbeb", border: "#fde68a", value: "#b45309" }
            : { bg: "#f8fafc", border: "#e2e8f0", value: "#0f172a" }

  return (
    <div
      style={{
        borderRadius: 16,
        border: `1px solid ${visual.border}`,
        background: visual.bg,
        padding: 12,
        display: "grid",
        gap: 4,
        alignContent: "start",
        minHeight: 92,
      }}
    >
      <div
        style={{
          fontSize: 11.5,
          fontWeight: 800,
          color: "#64748b",
          textTransform: "uppercase",
          letterSpacing: 0.3,
        }}
      >
        {title}
      </div>

      <div
        style={{
          fontSize: 22,
          lineHeight: 1.05,
          fontWeight: 900,
          color: visual.value,
          wordBreak: "break-word",
        }}
      >
        {value}
      </div>

      <div
        style={{
          fontSize: 12,
          color: "#64748b",
          lineHeight: 1.35,
        }}
      >
        {subtitle}
      </div>
    </div>
  )
}

export function EmptyStateBlock({ text, minHeight = 120 }) {
  return (
    <div
      style={{
        ...ui.emptyState,
        minHeight,
        background: "#ffffff",
      }}
    >
      {text}
    </div>
  )
}